<script lang="ts" setup>
import AccountMenuV2 from '@monolith/legacy/components/account/menu/account-menu-v2.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <div class="mobile-navigation-brand-account">
    <AkHeading3>{{ t('shared.menu.youraccount') }}</AkHeading3>
    <AccountMenuV2 />
  </div>
</template>

<style lang="css" scoped>
.mobile-navigation-brand-account {
  @apply ds-mt-4;
}
</style>
